import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { IconComponent } from '../icon/icon.component';
import { CommonModule } from '@angular/common';
import { NAV_LINKS_HOME } from '@app/utils/constants/nav-links.constants';
import { IconName } from '@app/utils/enums/icon-enum';
import { AppRoutes } from '@app/utils/enums/routes.enum';
import { NavLink } from '@app/utils/interfaces/nav-link.interface';

@Component({
  selector: 'app-home-sidebar',
  standalone: true,
  imports: [TranslateModule, RouterModule, IconComponent, CommonModule],
  templateUrl: './home-sidebar.component.html',
  styleUrl: './home-sidebar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomeSidebarComponent {
  public IconName = IconName;
  public appRoutes = AppRoutes;

  public links = input<NavLink[]>(NAV_LINKS_HOME); 

  public getIcon(iconKey: string): IconName {
    return IconName[iconKey as keyof typeof IconName];
  }
}
